export const UNITS = {
  celsius: "°C",
  farhenite: "°F",
  meter: "m",
  millimeter: "mm",
  centimeter: "cm",
  inch: "in",
  kilowatt: "kW",
  kiloWattHourPerDay: "kWh/d",
  kiloWattHour: "kWh",
  ppmv: "ppmv", //parts per million by volume
  gcm3: "g/cm³", //grams per cubic centimeter
  lbgl: "lb/gal", //pounds per gallon
  uscm: "µS/cm", //microsiemens per centimeter
  mscsm: "mS/cm", //millisiemens per centimeter
  bar: "bar",
  psi: "psi",
  psig: "psig",
  CUBIC_METER: "m³",
  METER: "m",
  BV_PER_HR: "BV/h",
  BV: "BV",
  GRAMS_PER_LITRE: "g/L",
  poundPerCubicFoot: "lb/ft³",
  MICROGRAM_LITRE: "µg/L",
  MiliEquivalentPerLiter: "meq/L",
  equivalentPerLiter: "eq/L",
  equivalent: "eq",
  gramNaOHPerGramSiO2: "g NaOH/g SiO₂",
  MiligramPerLiter: "mg/L",
  PartsPerMillion: "ppm CaCO₃",
  ppm: "ppm",
  MicroAtmosphere: "µatm",
  meterCubePerHour: "m³/h",
  lmh: "LMH",
  squareMeter: "m²",
  kiloGram: "kg",
  meterPerHour: "m/h",
  normalMeterCubePerHour: "Nm³/h",
  normalMeterCube: "Nm³",
  toc: "mg/L TOC",
  organicsKMnO4: "mg/L KMnO₄",
  pH: "pH",
  min: "min",
  hour: "h",
  day: "day",
  sec: "s",
  gallonsPerMin: "gpm",
  gallonsPerDay: "gpd",
  meterCubePerDay: "m³/d",
  literPerSecond: "L/s",
  kiloPascal: "kPa",
  gfd: "gfd",
  squareFoot: "ft²",
  horsePower: "hp",
  gpmft3: "gpm/ft³",
  liter: "L",
  gallon: "gal",
  killoGallon: "Kgal",
  cubicFoot: "ft³",
  pound: "lb",
  scfm: "scfm",
  scf: "scf",
  literPerHour: "L/h",
  ntu: "NTU",
  percentage: "%",
  minutesPerDay: "min/d",
  kigoGramPerSquareMeter: "kg/m²",
  kigoGramPerCubicMeter: "kg/m³",
  poundPerSquareFoot: "lb/ft²",
  gramPerLiterToc: "g/L TOC",
  gramPerLiterKMnO4: "g/L KMnO₄",
  gramPerLiterSiO2: "g/L SiO₂",
  gramPerMol: "g/mol",
};

export const UNIT_TYPES = {
  FLOW: 1,
  TEMPERATURE: 2,
  PRESSURE: 3,
  AREA: 5,
  GASES_CONCENTRATION: 6,
  DENSITY: 7,
  LENGTH: 8,
  POWER: 9,
  SPECIFIC_VELOCITY: 10,
  VOLUME_SOLUTION: 11,
  VOLUME_RESIN: 12,
  VOLUME_COMMON: 13,
  REGENERANT_DOSE: 14,
  LINEAR_VELOCITY: 15,
  WEIGHT: 16,
  CONDUCTIVITY: 17,
  GAS_FLOW: 18,
  ORGANICS: 19,
};

export const METRIC_UNITS = {
  [UNIT_TYPES.FLOW]: UNITS.meterCubePerHour,
  [UNIT_TYPES.PRESSURE]: UNITS.bar,
  [UNIT_TYPES.TEMPERATURE]: UNITS.celsius,
  [UNIT_TYPES.AREA]: UNITS.squareMeter,
  [UNIT_TYPES.GASES_CONCENTRATION]: UNITS.MicroAtmosphere,
  [UNIT_TYPES.CONDUCTIVITY]: UNITS.uscm,
  [UNIT_TYPES.DENSITY]: UNITS.gcm3,
  [UNIT_TYPES.LENGTH]: UNITS.millimeter,
  [UNIT_TYPES.POWER]: UNITS.kilowatt,
  [UNIT_TYPES.SPECIFIC_VELOCITY]: UNITS.BV_PER_HR,
  [UNIT_TYPES.VOLUME_SOLUTION]: UNITS.CUBIC_METER,
  [UNIT_TYPES.VOLUME_RESIN]: UNITS.CUBIC_METER,
  [UNIT_TYPES.VOLUME_COMMON]: UNITS.BV,
  [UNIT_TYPES.REGENERANT_DOSE]: UNITS.GRAMS_PER_LITRE,
  [UNIT_TYPES.LINEAR_VELOCITY]: UNITS.meterPerHour,
  [UNIT_TYPES.WEIGHT]: UNITS.kiloGram,
  [UNIT_TYPES.GAS_FLOW]: UNITS.normalMeterCubePerHour,
  [UNIT_TYPES.ORGANICS]: UNITS.toc,
};

export const GALLON_TO_LITER_CONVERSION_FACTOR = 3.78541;

// analyse and remove this if not required
export const CONCENTRATION_UNITS_MAPPING = {
  1: UNITS.MICROGRAM_LITRE,
  2: UNITS.MiliEquivalentPerLiter,
  3: UNITS.MiligramPerLiter,
  4: UNITS.PartsPerMillion,
};
